import {
  reclaimCampaignMatchKindSchema,
  reclaimCampaignRuleSchema,
} from "@redotech/redo-dispute-settings-common/reclaim-access-settings";
import * as z from "zod";

/** Keyed on (matchKind, matchValue): re-sending an existing key edits it. */
export const upsertReclaimCampaign = {
  name: "upsertReclaimCampaign" as const,
  input: z.object({ campaign: reclaimCampaignRuleSchema }),
  output: z.object({ campaigns: z.array(reclaimCampaignRuleSchema) }),
};

export const deleteReclaimCampaign = {
  name: "deleteReclaimCampaign" as const,
  input: z.object({
    matchKind: reclaimCampaignMatchKindSchema,
    matchValue: z.string().min(1).max(200),
  }),
  output: z.object({ campaigns: z.array(reclaimCampaignRuleSchema) }),
};
